import React from 'react'
function ViewMaterial({ item, data, open, onCancel }) {
  const displayItem = item || data;

  return (


    <div className=" w-full h-auto grid grid-cols-1  md:grid-cols-3">
 
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Item</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.item|| "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Category</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.category || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Division</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.division || "-"}</p>
      </div>

      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'> Quantity</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.quantity || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Unit</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.unit || "-"}</p>
      </div>
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Amount</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.amount || "-"}</p>
      </div>
      {/* <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Hours</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.hours || "-"}</p>
      </div> */}
      <div className='my-2'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Comment</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.comments || "-"}</p>
      </div>
      
    </div>
  )
}

export default ViewMaterial